import {GeoJSON} from 'ol/format';
import View from 'ol/View.js';

import constants, {dynamicUrl} from 'api/constants.js';
import createProjection from 'ngeo/proj/utils';

//import EPSG2154 from "macommune/epsg2154.js";
import Map from 'macommune/map.js';
import themesDefinitions from 'macommune/themes.js';

class Controller {
  constructor(options) {
    const request = new XMLHttpRequest();
    request.open('GET', dynamicUrl.dynamicUrl, false);
    request.send(null);

    if (request.status !== 200) {
      throw new Error('Error on getting the dynamic configuration');
    }

    Object.assign(constants, JSON.parse(request.responseText)['constants']);
    for (const code in constants.projections) {
      createProjection(
        code,
        constants.projections[code].definition.join(' '),
        constants.projections[code].extent
      );
    }

    this.themesDefinitions = themesDefinitions;
    this.communeAutocompleteUrl = options.communeAutocompleteUrl;
    this.communeGeoJSONUrl = options.communeGeoJSONUrl;
    this.dataUrl = options.dataUrl;
    this.dataAbortControllers = []; // To abort pending data requests

    this.map = new Map({
      themesUrl: options.themesUrl,
      localeUrl: options.localeUrl,
      target: 'map', // id of the div element to put the map in
      view: new View({
        projection: 'EPSG:2154',
        resolutions: [
          3266.5595244627, 1633.2660045974, 816.629554986, 408.3139146768, 204.1567415109, 102.0783167832,
          51.0391448966, 25.5195690743, 12.7597836936, 6.379891636, 3.1899457653, 1.5949728695, 0.797486431,
          0.3987432149, 0.1993716073, 0.0996858037, 0.0498429018,
        ],
        center: [1029781, 6817958],
        zoom: 5,
      }),
    });

    window.map = this.map; // For debug purpose

    this.map.on('click', (e) => {
      if (!this.extentSelection && !this.codecommune) {
        this.refreshData(e.coordinate);
      } else {
        const feature = this.map.forEachFeatureAtPixel(e.pixel, (feat) => feat, {
          layerFilter: (layer) => layer.get('name') === 'featureLayer',
          hitTolerance: 10,
        });
        this.map.selectionSource.clear();
        $('.selected-card').removeClass('selected-card');
        if (feature) {
          this.map.selectionSource.addFeature(feature);
          const divId = feature.getId();
          $('#' + divId).addClass('selected-card');
          const scrollPosition = $('#data-panel').scrollTop();
          $('#data-panel').animate(
            {
              scrollTop: scrollPosition + $('#' + divId).offset().top - 100,
            },
            500
          );
        }
      }
    });

    $('#data-panel').on('click', '.detail-card', (e) => {
      this.map.selectionSource.clear();
      $('.selected-card').removeClass('selected-card');
      const divId = e.target.id;
      if (divId) {
        $('#' + divId).addClass('selected-card');
        this.map.featureSource.getFeatures().forEach((feature) => {
          if (feature.getId() == divId) {
            this.map.selectionSource.addFeature(feature);
          }
        });
      }
    });

    $('#map').on('click', () => this.collapseAll());
    $('#navbar-toggle-btn').on('click', () => this.collapseAll(false));
    $('#themes-toggle-btn').on('click', () => this.togglePanel($('#themes-panel')));
    $('#search-toggle-btn').on('click', () => this.togglePanel($('#search-panel')));
    $('#data-toggle-btn').on('click', () => this.togglePanel($('#data-panel')));

    $('.theme-btn').on('click', (e) => {
      $('#themes-panel').removeClass('in');
      this.setTheme($(e.currentTarget).data('theme'));
      return false;
    });

    this.communeMagicSuggest = $('#commune-selector').magicSuggest({
      placeholder: 'Choisissez une Commune',
      data: this.communeAutocompleteUrl,
      minChars: 3,
      groupBy: 'nomregion',
      maxSelection: 1,
      valueField: 'name',
      allowFreeEntries: false,
      hideTrigger: true,
    });

    $(this.communeMagicSuggest).on('selectionchange', () => {
      if (this.communeMagicSuggest.getSelection().length == 0) {
        this.setCommune(null);
        $('#commune-return').addClass('collapse');
      } else {
        $('#search-panel').removeClass('in');
        $('#commune-return').removeClass('collapse');
        this.setCommune(this.communeMagicSuggest.getSelection()[0].id);
      }
    });
    if (options.commune) {
      this.communeMagicSuggest.setSelection([options.commune]);
    }

    $('#commune-return').on('click', () => {
      if (this.communeMagicSuggest.getSelection().length !== 0) {
        this.setCommune(this.communeMagicSuggest.getSelection()[0].id);
      }
    });

    $('.extent-selection-control button').on('click', () => {
      this.extentSelection = this.map.extentSelectionControl.active;
      this.refreshData();
    });
    this.extentSelection = false;
    this.map.on('moveend', () => {
      if (this.extentSelection) {
        this.refreshData();
      }
    });

    const searchParams = new URL(location.href).searchParams;
    this.map.loadBackgrounds().then(() => {
      this.setTheme(searchParams.get('theme'));
      this.setCommune(searchParams.get('codecommune'));
    });
  }

  collapseAll(navbar = true) {
    if (navbar) {
      $('#navbar-collapse').removeClass('in');
    }
    $('#themes-panel').removeClass('in');
    $('#search-panel').removeClass('in');
    $('#message-panel').removeClass('in');
    $('#data-panel').removeClass('in');
  }

  togglePanel(panel) {
    let visible = panel.hasClass('in');
    this.collapseAll();
    if (!visible) {
      panel.toggleClass('in');
    }
  }

  setCommune(codecommune) {
    this.codecommune = codecommune;
    if (this.codecommune) {
      var geojson = $.get(this.communeGeoJSONUrl + '/' + this.codecommune, (data) => {
        const format = new GeoJSON();
        var feature = format.readFeature(data);
        this.map.selectCommune(feature);
      });
    } else {
      this.map.clearCommune();
    }
    this.refreshData();
  }

  setTheme(ref) {
    if (ref) {
      this.currentTheme = this.themesDefinitions.filter((t) => t.ref == ref)[0];
    } else {
      this.currentTheme = null;
    }
    this.map.selectTheme(this.currentTheme);
    this.refreshData();
  }

  clearData() {
    this.map.featureSource.clear();
    this.map.selectionSource.clear();
    $('#data-header').html('Aucune sélection');
    $('#details').html('');
    $('#synthesis').html('');
  }

  refreshData(clickCoordinates) {
    // Abort pending data requests
    let ctrl;
    while ((ctrl = this.dataAbortControllers.pop())) {
      ctrl.abort();
    }

    this.clearData();

    // Construct request parameters
    if (!this.currentTheme) {
      return;
    }
    if (this.currentTheme.detailRenderer === undefined && this.currentTheme.synthesisRenderer === undefined) {
      return;
    }

    let params = {};
    if (this.extentSelection) {
      const bbox = this.map.getView().calculateExtent(this.map.getSize());
      params['bbox'] = bbox.join(',');
    } else if (this.codecommune != undefined) {
      params['codecommune'] = this.codecommune;
    } else if (clickCoordinates != undefined) {
      const pixelTolerance = 10;
      const meterTolerance = map.getView().getResolution() * pixelTolerance;
      const bbox = [
        clickCoordinates[0] - meterTolerance,
        clickCoordinates[1] - meterTolerance,
        clickCoordinates[0] + meterTolerance,
        clickCoordinates[1] + meterTolerance,
      ];
      params['bbox'] = bbox.join(',');
    } else {
      return;
    }

    // Send request
    let url = new URL(this.dataUrl + '/' + this.currentTheme.ref);
    for (let key in params) {
      url.searchParams.append(key, params[key]);
    }
    $('#data-loading').removeClass('hidden');
    $('#data-content').addClass('hidden');
    ctrl = new AbortController();
    this.dataAbortControllers.push(ctrl);
    fetch(url, {
      method: 'GET',
      signal: ctrl.signal,
    })
      .finally(() => {
        $('#data-loading').addClass('hidden');
        $('#data-content').removeClass('hidden');
      })
      .then((response) => response.json())
      .then((data) => {
        if (!data.success) {
          this.showMessage(data.error || "Une erreur s'est produite");
          return;
        }

        // Parse response and display data
        if (data.hasOwnProperty('details')) {
          this.map.featureSource.clear();
          this.map.featureSource.addFeatures(this.currentTheme.features(data));
        }
        $('#data-content').html(this.currentTheme.dataRenderer(data));
      })
      .catch((err) => {
        if (err.name === 'AbortError') {
          console.log('Fetch aborted');
        } else {
          console.error(err);
        }
      });
  }

  showMessage(msg) {
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
      this.messageTimeout = undefined;
    }

    $('#message-box').html(msg);
    const panel = $('#message-panel');
    panel.addClass('in');

    this.messageTimeout = setTimeout(function () {
      panel.removeClass('in');
    }, 3000);
  }
}

export default Controller;
